import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PopupButton, InlineWidget } from "react-calendly";
import Base13Icon from './../../Color just logo - no background.svg';
import Spock from './../../spockComputer.png';

import Header from './Header';
import Footer from './Footer';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
    justifyContent: 'left',
    justify: 'left',
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    resizeMode: 'contain'
  },
  spock: {
    flex: 1,
    padding: 2,
    maxWidth: 320,
    resizeMode: 'contain'
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  // image: {
  //   flex: 1,
  //   padding: 2,
  //   width: 100,
  //   height: 100,
  //   resizeMode: 'contain'
  // },
  text: {
    margin: theme.spacing(1),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardContent: {
    backgroundColor: 'white',
    color: '#0284c7'
  },
}));

export default function FormSubmitted() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>

       <Container maxWidth="lg" component="main" className={classes.heroContent} style={{color:"#37474f"}} >
          <Box style={{padding: 50}}></Box>
          <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{paddingTop:30, paddingBottom:20}}
          >
            <img className={classes.image} src={Base13Icon}/>
          </Box>
          <Typography component="h3" style={{padding:20}} variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
            You are now on our waitlist.
          </Typography>
          <Typography component="h3" style={{padding:20}} variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
            Thank you for your interest our FREE version of FloSQL.
          </Typography>
          <Box style={{padding:20}}></Box>
          <Typography component="h3" style={{padding:20}} variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textSecondary" gutterBottom>
            You will receive an email once your are at the top of the list.
          </Typography>
          <Typography component="h3" style={{padding:20}} variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textSecondary" gutterBottom>
            Please ensure that our email is not in your junkmail.
          </Typography>

        <Box style={{padding:50}}></Box>

        </Container>
      <Footer/>
    </React.Fragment>
  );
};
